import { render } from "./component-pd-addr-fmt.vue?vue&type=template&id=c145ab50"
import script from "./component-pd-addr-fmt.vue?vue&type=script&setup=true&lang=js"
export * from "./component-pd-addr-fmt.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-card/field-wrappers/component-pd-addr-fmt.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c145ab50"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c145ab50', __exports__)) {
    api.reload('c145ab50', __exports__)
  }
  
  module.hot.accept("./component-pd-addr-fmt.vue?vue&type=template&id=c145ab50", () => {
    api.rerender('c145ab50', render)
  })

}


export default __exports__